<script lang="ts">
import type { I3pService } from '../../services/i3p.service'
import type { HelperService } from '../../utils/helper.service'
import { TransformerService } from '../../services/transformer.service'

export default {

    props: {
        baseUrl: { type: String, required: false, default: null },
    },

    computed: {
        i3pService(): I3pService {
            return this.getI3pComponent()?.$props?.i3pService as I3pService
        },
        isMine(): boolean {
            return this.baseUrl?.startsWith('/mes')
        },
    },
    methods: {
        getI3pComponent() {
            const helper: HelperService = this.$helper
            return helper.getAncestorByComponentName(this, 'I3p')
        },

        // Map TEMPLATE METHODS to Transform service
        isChips(key, value, template) {
            return (new TransformerService()).isChips(key, value, template, this.translationName)
        },
        isMultipleChips(key, value, template) {
            return (new TransformerService()).isMultipleChips(key, value, template, this.translationName)
        },
        toTranslate(key, value) {
            return (new TransformerService()).toTranslate(key, value, this.translationName)
        },
        hasUrlProperty(key, value) {
            return (new TransformerService()).hasUrlProperty(key, value)
        },
        isDate(key, value) {
            return (new TransformerService()).isDate(key, value)
        },
        isNumericDate(key, value) {
            return (new TransformerService()).isNumericDate(key, value)
        },
        isDateTime(key, value) {
            return (new TransformerService()).isDateTime(key, value)
        },
        isBold(key, value) {
            return (new TransformerService()).isBold(key, value)
        },
        isBoolean(key, value) {
            return (new TransformerService()).isBoolean(key, value)
        },
        isCroppedField(key, value: string, length = 100) {
            return (new TransformerService()).isCroppedField(key, value, length)
        },
        isCroppedWithTooltip(key, value, template, length = 100) {
            return (new TransformerService()).isCroppedWithTooltip(key, value, template, length)
        },
        textLeft(key, value, template) {
            return (new TransformerService()).textLeft(key, value, template)
        },

        // -------------------------

    },
}
</script>
